import { Route, Navigate } from "react-router-dom";
import CompaniesScreen from "../../../container/System/CompaniesScreen";
import CreateCompaniesContainer from "../../../container/System/CompaniesScreen/CreateCompanies";
import { APP_URLS } from "../../../utils/constant";
const isSuperAdminCompany = () => localStorage.getItem('companyId') === '1';

const CompaniesRoutes = (access = {}) => {
  const { view, create, edit = false } = access;

  return (
    <>
      {!!view && (
        <Route
          path={APP_URLS.SYSTEM_COMPANIES.HOME}
          element={isSuperAdminCompany() ? <CompaniesScreen screenPermissions={access} /> : <Navigate to="/unauthorized" replace />}
        />
      )}
      {!!create && (
        <Route
          path={APP_URLS.SYSTEM_COMPANIES.CREATE}
          element={isSuperAdminCompany() ? <CreateCompaniesContainer /> : <Navigate to="/unauthorized" replace />}
        />
      )}
      {!!edit && (
        <Route
          path={APP_URLS.SYSTEM_COMPANIES.EDIT}
          element={isSuperAdminCompany() ? <CreateCompaniesContainer isEdit={true} /> : <Navigate to="/unauthorized" replace />}
        />
      )}
    </>
  );
};

export default CompaniesRoutes;
